import { getUserData, secureStorage } from "../constants/EncryptedLocalStorage";

export const hasUserCompletedSpecialization = async() => {
  try {
    const userData = await getUserData()
    const specializationCompleted = localStorage.getItem("specializationCompleted");
    
    const hasSubcategory = !!(userData?.data?.subcategory);
    const isMarkedCompleted = specializationCompleted === "true";
    
    return hasSubcategory || isMarkedCompleted;
  } catch (error) {
    console.error("Error checking specialization status:", error);
    return false;
  }
};

export const getUserSpecializations = () => {
  try {
    const specializations = localStorage.getItem("userSpecializations");
    return specializations ? JSON.parse(specializations) : [];
  } catch (error) {
    console.error("Error getting user specializations:", error);
    return [];
  }
};

export const markSpecializationCompleted =async (specializations, subcategory) => {
  try {
    
    // Update SignupData with subcategory
    const localData = await getUserData()

    
    if (!localData.data) {
      localData.data = {};
    }
    
    localData.data.subcategory = subcategory;
   await secureStorage.setItem("SecureSignupData", JSON.stringify(localData));    
    // Mark as completed
    localStorage.setItem("specializationCompleted", "true");
    localStorage.setItem("userSpecializations", JSON.stringify(specializations));
    
    // Get the return path
    const returnPath = localStorage.getItem("returnAfterSpecialization");
    // Return the path to redirect to (default to /feed if no return path)
    return returnPath && returnPath !== "/specialization" ? returnPath : "/feed";
  } catch (error) {
    console.error("Error marking specialization as completed:", error);
    return "/feed"; // Fallback to feed page
  }
};

export const isNewUser = async(userData) => {
  try {
    const hasToken = !!(userData?.data?.id);
    const hasCompletedSpecialization = await hasUserCompletedSpecialization();
        
    // User is considered new if they have a token but haven't completed specialization
    return hasToken && !hasCompletedSpecialization;
  } catch (error) {
    console.error("Error checking if user is new:", error);
    return false;
  }
};

export const handleUserLogout = () => {
  try {
    localStorage.removeItem("SignupData");
    localStorage.removeItem("specializationCompleted");
    localStorage.removeItem("userSpecializations");
    localStorage.removeItem("returnAfterSpecialization");
    // Add any other cleanup needed    
  } catch (error) {
    console.error("Error during logout:", error);
  }
};


export const setReturnPath = (path) => {
  if (path && path !== "/specialization") {
    localStorage.setItem("returnAfterSpecialization", path);
  } else {
  }
};

export const getReturnPath = () => {
  const path = localStorage.getItem("returnAfterSpecialization");
  return path;
};

export const isValidReturnPath = (path) => {
  if (!path || typeof path !== 'string') return false;
  
  const invalidPaths = [
    '/login',
    '/signup', 
    '/register',
    '/auth',
    '/specialization'
  ];
  
  return !invalidPaths.some(invalidPath => 
    path.toLowerCase().includes(invalidPath.toLowerCase())
  );
};

export const getSafeReturnPath = () => {
  const storedPath = getReturnPath();
  
  if (isValidReturnPath(storedPath)) {
    return storedPath;
  }
  
 
  return "/feed";
};